var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"px-2 tracking-widest translate-y-[-1px]",attrs:{"color":_vm.labelConfig.color,"text-color":_vm.labelConfig.textColor,"x-small":true}},[_vm._v(" "+_vm._s(_vm.labelConfig.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }